module.exports = __webpack_public_path__ + "img/loader.87321c1f.gif";